import React from  'react';
import CarouselContainerSilicon from '../CarouselContainerSilicon';

function TimelineExplainerSilicon() {
    return (
        <div className="Timeline">
            <CarouselContainerSilicon/>
        </div>
    );
}

export default TimelineExplainerSilicon;


